export default __webpack_public_path__ + "static/media/gb.334e7105.svg";